import { NotificationTypes } from '../types/notifications';

export const EMPLOYEE_NOTIFICATIONS = [
  NotificationTypes.CHAT_MESSAGE,
  NotificationTypes.APPOINTMENT_REQUESTED,
  NotificationTypes.APPOINTMENT_SCHEDULED,
  NotificationTypes.APPOINTMENT_RESCHEDULED,
  NotificationTypes.APPOINTMENT_CANCELED,
  NotificationTypes.APPOINTMENT_REMINDER,
  NotificationTypes.PAYMENT_RECEIVED,
];

export const MANAGER_NOTIFICATIONS = [
  NotificationTypes.MANAGER_NEW_REQUEST,
  NotificationTypes.MANAGER_NEW_GENERAL_REQUEST,
  NotificationTypes.MANAGER_APPOINTMENT_SCHEDULED,
  NotificationTypes.MANAGER_APPOINTMENT_CANCELED,
];

export const NOTIFICATION_DETAILS = {
  [NotificationTypes.CHAT_MESSAGE]: {
    label: 'Chat Messages',
    description: 'Never miss important messages from your clients',
  },
  [NotificationTypes.APPOINTMENT_REQUESTED]: {
    label: 'Appointment Requests',
    description: 'Stay updated when new appointments are requested',
  },
  [NotificationTypes.APPOINTMENT_SCHEDULED]: {
    label: 'Appointment Scheduled',
    description: 'Stay updated when appointments are added to your calendar',
  },
  [NotificationTypes.APPOINTMENT_RESCHEDULED]: {
    label: 'Appointment Rescheduled',
    description: 'Stay updated when appointments are rescheduled',
  },
  [NotificationTypes.APPOINTMENT_CANCELED]: {
    label: 'Appointment Canceled',
    description: 'Stay updated when appointments are canceled',
  },
  [NotificationTypes.APPOINTMENT_REMINDER]: {
    label: 'Appointment Reminders',
    description:
      'Never miss important reminders about your upcoming appointments',
  },
  [NotificationTypes.PAYMENT_RECEIVED]: {
    label: 'Checkout Processed',
    description: 'Stay updated when appointment checkouts are processed',
  },
  [NotificationTypes.MANAGER_NEW_REQUEST]: {
    label: 'New Request',
    description: 'Stay updated when new requests are received',
  },
  [NotificationTypes.MANAGER_NEW_GENERAL_REQUEST]: {
    label: 'New General Request',
    description: 'Stay updated when new general requests are received',
  },
  [NotificationTypes.MANAGER_APPOINTMENT_SCHEDULED]: {
    label: 'Appointment Scheduled',
    description:
      "Stay updated when appointments are added to employees' calendars",
  },
  [NotificationTypes.MANAGER_APPOINTMENT_CANCELED]: {
    label: 'Appointment Canceled',
    description: 'Stay updated when appointments are canceled',
  },
};
